module.exports = __webpack_public_path__ + "img/77.6.CODm.5a2e2d4d.png";